/**
 * tutoriales.ts — Web data-layer for the SELF-SERVICE tutorial progress (R34).
 * The logged-in user marks their own spotlight tours as seen. The admin reset of
 * another user's progress lives in `lib/usuarios.ts`.
 */

import { apiGet, apiPost } from '@/lib/apiClient';

/** GET /tutoriales/me — the current user's completed tutorial keys. */
export async function getTutorialesCompletados(): Promise<string[]> {
	const res = await apiGet<{ completados: string[] }>('/tutoriales/me');
	return res.completados;
}

/** POST /tutoriales/me/:clave — mark a tutorial completed (idempotent). */
export async function marcarTutorialCompletado(clave: string): Promise<{ completados: string[] }> {
	return apiPost<{ completados: string[] }>(`/tutoriales/me/${encodeURIComponent(clave)}`);
}

/**
 * Signal that an in-app action completed a tutorial step (e.g. the user toggled a
 * section or reordered by drag). A step with a matching `advanceOnEvent` listens
 * for this and advances. No-op cost when no tour is active — nothing listens.
 */
export function dispatchTutorialAdvance(event: string): void {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent('siiv-tutorial-advance', { detail: event }));
}
